import {
  defaultFilterKeys,
  defaultLinearDatasetOptions,
  defaultLinearFilters,
  defaultLinearOptions,
  getCssColor,
  getFormatedDate,
  getGroupedData,
  today,
} from '@/utils/analytics'

/**
 * @param {vueInstance} context - This.
 * @returns {LinearChart} The chart configuration object.
 */
export default function (context) {
  return {
    key: 'project_page_status',
    resource: {
      endpoint: 'project_page_status',
      filter: {
        'filter.start': defaultFilterKeys[30],
        'filter.end': today(),
      },
    },
    type: 'Linear',
    filterBy: {
      initial: 30,
      label: context.$t('select'),
      key: 'filter.start',
      values: defaultLinearFilters.map(filter => ({ ...filter, label: context.$t(filter.label) })),
    },
    title: {
      id: 'project_page_status',
      label: context.$t('statisticsVisitors'),
      style: true,
    },
    total: ({ data = {} }) => ({ project_page_status: context.valueParser(data.total) }),
    dimensions: [
      {
        id: 'project_page_status',
        label: `${context.$t('statisticsVisitors')} ${context.$t('total').toLowerCase()}`,
        icon: '',
        marker: getCssColor('primary'),
        backgroundColor: getCssColor('primary', 0.5),
        borderColor: getCssColor('primary'),
        value: ({ data = {} }) => (data.keys ? data.keys.map(key => getGroupedData(data, key)) : []),
      },
    ],
    colors: {},
    options: ({ source }) => ({
      ...defaultLinearOptions({ source }),
    }),
    data: ({ data = {}, dimensions = {} }) => {
      const labels = data.keys ? data.keys.map(key => getFormatedDate(key)) : []
      return {
        labels,
        datasets: Object.values(dimensions).map(dimension => {
          return {
            ...defaultLinearDatasetOptions,
            data: dimension.value({ data }),
            backgroundColor: dimension.backgroundColor,
            borderColor: dimension.borderColor,
          }
        }),
      }
    },
  }
}
